var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionmarkCircle = function SvgQuestionmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0875C4",
    fillRule: "evenodd",
    d: "M8 1.334C4.326 1.334 1.333 4.326 1.333 8S4.326 14.667 8 14.667 14.666 11.674 14.666 8 11.673 1.334 8 1.334m0 12A5.34 5.34 0 0 1 2.666 8 5.34 5.34 0 0 1 8 2.667 5.34 5.34 0 0 1 13.333 8 5.34 5.34 0 0 1 8 13.334m0-1.167A.833.833 0 1 0 8 10.5a.833.833 0 0 0 0 1.667m-2.667-5.5c0-1.1.9-2 2-2h1.333c1.1 0 2 .9 2 2s-.9 2-2 2V10H7.333V8.667c0-.733.6-1.333 1.333-1.333.367 0 .667-.3.667-.667S9.033 6 8.666 6H7.333c-.367 0-.667.3-.667.667v.667H5.333z",
    clipRule: "evenodd"
  })));
};
export { SvgQuestionmarkCircle as Icon };
export default __webpack_public_path__ + "static/media/fd112ff659e6a1ea6666f894807f3d2b.svg";